module.exports = __webpack_public_path__ + "static/img/8.d7002dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/sp/8.png
// module id = ZTXL
// module chunks = 0